import * as fromDatatype from '../datatype-library/index'

export interface bl_mrp_job_template_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    process_type_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    descr: fromDatatype.TextDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision:  fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    inv_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
};

export class bl_mrp_job_template_hdr_RowClass implements bl_mrp_job_template_hdr_RowInterface
  {
    guid: fromDatatype.GuidDataFieldInterface;
    process_type_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    descr: fromDatatype.TextDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision:  fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    inv_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  }
